import { Box, BoxProps, Button, Flex, Icon, Link, Text } from '@chakra-ui/react';
import { useResource } from 'datx-jsonapi-react';
import NextLink from 'next/link';
import { useRouter } from 'next/router';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import ContactUs from '@/assets/icons/ic-nav-help-desk.svg';

import { EventTicketDescriptionMarkdown } from '@/components/ui/shared/markdowns/EventTicketDescriptionMarkdown/EventTicketDescriptionMarkdown';
import { queryThinEvent } from '@/queries/thin-events';

interface IRegistrationFeeProps extends BoxProps {
  eventId: string;
}

export const RegistrationFee: FC<IRegistrationFeeProps> = ({ eventId, ...props }) => {
  const { t } = useTranslation();
  const router = useRouter();

  const { data: event } = useResource(queryThinEvent(eventId));

  return (
    <Box shadow="card" bgColor="white" borderRadius={8} p={4} {...props}>
      <Box borderRadius={8} bgColor="gray.50" p={4} mb={{ base: 4, lg: 5 }}>
        {event.missingTicketDescription ? (
          <EventTicketDescriptionMarkdown source={event.missingTicketDescription} />
        ) : (
          <Text>{t('eventTicketRegister.registrationFeeMessage')}</Text>
        )}
      </Box>
      <Flex mb={2} flexDirection={{ base: 'column', lg: 'row' }} alignItems="center">
        <Flex
          justifyContent="space-between"
          flexDirection={{ base: 'column', md: 'row' }}
          gap={2}
          alignItems={{ base: 'flex-start', md: 'center' }}
          w="full"
        >
          <Box w="full">
            <Flex w="full" flexDirection={{ base: 'column', md: 'row' }} gap={4} mb={5}>
              {event?.registrationUrl && (
                <NextLink href={event?.registrationUrl} target="_blank" passHref legacyBehavior>
                  <Button w="full" as="a" size="sm">
                    {t('eventTicketRegister.registrationFeeAction')}
                  </Button>
                </NextLink>
              )}
              <NextLink href={`/log-in?redirectUrl=${router.asPath}&stay=true`} passHref legacyBehavior>
                <Button w="full" minW="240px" variant="outline" as="a" size="sm">
                  {t('eventTicketRegister.logInDifferentEmail')}
                </Button>
              </NextLink>
            </Flex>
            <Text as="span" mr={4}>
              {t('eventTicketRegister.needHelp')}
            </Text>
            <NextLink
              href={{
                pathname: '/contact-us/support',
                query: { eventId: event.id },
              }}
              passHref
              legacyBehavior
            >
              <Link fontWeight="bold">
                {t('eventTicketRegister.contactUs')} <Icon as={ContactUs} ml={2} />
              </Link>
            </NextLink>
          </Box>
        </Flex>
      </Flex>
    </Box>
  );
};
